import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import StatsRow from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/StatsRow'
import { isHourlyFixedBalanceAllowance } from 'modules/timeoff/components/Leaves/Overview/formatCounterAmount'
import type Allowance from 'modules/timeoff/store/models/Allowance'
import type {
  Cycle,
  ParsedAllowanceStat,
} from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/allowanceStatUtils'

import BalanceTooltip from './BalanceTooltip'

interface Props {
  allowance: Allowance
  selectedStat: ParsedAllowanceStat
  selectedCycle: Cycle
  nextCycle: Cycle | null | undefined
}

const Balance = ({ allowance, selectedStat, selectedCycle, nextCycle }: Props) => {
  const stat = selectedStat.toJS()

  const accrued = stat.effective_accrued ?? 0
  const advance = stat.advance ?? 0

  return (
    <StatsRow
      title={i18n.t('time_off.cycle_balance')}
      amount={stat.available_days}
      isHourlyFixedBalance={isHourlyFixedBalanceAllowance(allowance)}
      tooltip={
        <BalanceTooltip
          accrued={accrued}
          allowance={allowance}
          carryOver={stat.accumulated_carry_over}
          incidence={stat.incidences}
          selectedCycle={selectedCycle}
          nextCycle={nextCycle}
          advance={advance}
        />
      }
    />
  )
}

export default Balance
